"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var react_toastify_1 = require("react-toastify");
var react_query_1 = require("react-query");
var trans_1 = __importDefault(require("@/plugins/trans"));
var VacancyAlertForm_1 = __importDefault(require("../components/VacancyAlertForm"));
var VacancyAlert_1 = require("../../models/VacancyAlert");
var VacancyAlertAddDialog = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var queryClient = (0, react_query_1.useQueryClient)();
    var createVacancyAlert = (0, react_query_1.useMutation)(VacancyAlert_1.create, {
        onSuccess: function (_a) {
            var data = _a.data;
            react_toastify_1.toast.success(data.message, {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: true,
                pauseOnHover: false,
            });
            queryClient.invalidateQueries('vacancy_alerts');
            handleClose();
        },
    });
    var handleCreateVacancyAlert = (0, react_1.useCallback)(function (input) {
        var newInput = __assign({}, input);
        if (input.location.value) {
            newInput.location = input.location.value.place_id;
        }
        createVacancyAlert.mutate({
            input: newInput,
        });
    }, [createVacancyAlert]);
    var handleClose = (0, react_1.useCallback)(function () {
        navigate('/vacancy-alerts');
    }, [navigate]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, __assign({ fullWidth: true, open: true, onClose: handleClose }, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { children: trans_1.default.get('labels.frontend.vacancy_alert.dialog.add.title') }), (0, jsx_runtime_1.jsx)(VacancyAlertForm_1.default, { onSubmit: handleCreateVacancyAlert })] })));
};
exports.default = VacancyAlertAddDialog;
